import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, isPepRouteEnabled = false, serverPages = {}) => {
  return {
    home: {
      name: 'Home',
      componentName: 'Home',
      chunk: () => import('./pages/Home'),
      get component() {
        if (ssr) {
          return serverPages.Home;
        }
        if (currentRouteName === 'Home') {
          return currentRouteComponent;
        }
        return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
      },
      path: '/:context?/c/alp/:category/:pageFilters/:page?',
      prefetch: [],
      channel: null,
      varnish: true,
    }
  };
};
